import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../Redux/User/userSlice";
import exhibitReducer from "../Redux/Exhibits/exhibitSlice";
import loadingReducer from "../Redux/Loader/loadingSlice";

//Store
export const store = configureStore({
  reducer: {
    user: userReducer,
    exhibits: exhibitReducer,
    loading: loadingReducer,
  },
});
